import { render, staticRenderFns } from "./RandomRestaurant.vue?vue&type=template&id=4282724f&"
import script from "./RandomRestaurant.vue?vue&type=script&lang=js&"
export * from "./RandomRestaurant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports